import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box, Toolbar } from "@mui/material";
import PatientNavBar from "../components/patient/PatientNavBar";
import PatientSidebar from "../components/patient/PatientSidebar";
import SEO from '../components/SEO';
const PatientLayout = () => {
  const [collapsed, setCollapsed] = useState(true);
  const toggleDrawer = () => {
    setCollapsed(prev => !prev);
  };
  return (
    <>
      <SEO />
      <Box display="flex" minHeight="100vh">
        <PatientNavBar toggleDrawer={toggleDrawer} /> 
        <PatientSidebar collapsed={collapsed} />
        <Box 
          component="main" 
          sx={{
            flexGrow: 1,
            transition: 'margin-left 0.3s ease',
            p: 3,
          }}>
          <Toolbar />
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default PatientLayout;